import { encode as base64_encode } from "base-64";
import { message } from "antd";
import config from "../config";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class FleetTempSummaryReportStore {
  fleetTempSummary = [];
  total = 0;
  loading = false;
  rootStore;
  remaning_vehicleId = "";
  last_record_timestamp = "";
  pythonReportMessage = false;
  pythonReportErrorMessage = false;

  constructor(rootStore) {
    makeObservable(this, {
      fleetTempSummary: observable,
      total: observable,
      loading: observable,
      loadData: action,
      exportExcel: action,
      exportpdf: action,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    interval,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      interval: interval,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient('report')
        .post("/fleet_report/fleettempsummary", postData);
    } else {
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
          .getClient()
          .post(
            "index.php?c=vehicle&a=fleetTempSummaryData",
            "postData=" + base64Input
          );
        }
        this.total = parseInt(response?.data?.data?.TotalCount);
    // }

    // if (config.pythonReport === 1) {
    //   this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
    //   this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId;
    // }

    this.fleetTempSummary = response?.data?.data?.temprep;
    this.loading = false;
  }
  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      

      try {
        await postApi
          .getClient("report")
          .post("/fleet_report/fleettempsummary/download/excel", getData, {
            responseType: "blob",
          });

        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportfleettempsummaryexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      

      try {
        await postApi
          .getClient("report")
          .post("/fleet_report/fleettempsummary/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicle&a=exportfleettempsummarypdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
}

export default FleetTempSummaryReportStore;